import React from 'react';
import { base44 } from '@/api/base44Client';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { History } from 'lucide-react';
import { useRecentlyViewed } from '@/lib/productStore';

export default function RecentlyViewed({ excludeId }) {
  const rv = useRecentlyViewed().filter((id) => id !== excludeId);

  const { data: products = [] } = useQuery({
    queryKey: ['recently-viewed-products', rv.join(',')],
    queryFn: async () => {
      if (!rv.length) return [];
      const all = await base44.entities.Product.list();
      return rv.map((id) => all.find((p) => p.id === id)).filter(Boolean);
    },
    enabled: rv.length > 0,
  });

  if (products.length === 0) return null;

  return (
    <section className="px-6 lg:px-10 pb-14 max-w-7xl mx-auto">
      <div className="flex items-center gap-2 mb-5">
        <History className="w-4 h-4 text-primary" />
        <h2 className="text-white font-black text-xl uppercase">Recently Viewed</h2>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
        {products.slice(0, 10).map((p, i) => (
          <motion.div key={p.id} initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.03 }}>
            <Link to={`/shop/${p.custom_slug || p.id}`} className="group block bg-[#111115] hover:bg-[#1a1a1f] transition-colors h-full">
              <div className="aspect-square bg-muted/30 overflow-hidden p-3 flex items-center justify-center">
                {p.image_url ? (
                  <img src={p.image_url} alt={p.name} className="max-w-full max-h-full object-contain group-hover:scale-105 transition-transform duration-400" />
                ) : (
                  <span className="text-white/10 text-xs">NO IMAGE</span>
                )}
              </div>
              <div className="p-3">
                <p className="text-white/80 text-xs font-bold leading-snug line-clamp-2 group-hover:text-primary transition-colors">{p.name}</p>
                <p className="text-white font-bold text-sm mt-1.5">£{Number(p.price || 0).toFixed(2)}</p>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </section>
  );
}